<script lang="ts" setup>
import ListItem from './PageHeaderListItem.vue';
import ResourceTools from './ResourceTools.vue';
</script>

<template>
  <ul class="m-0 flex list-none justify-between px-0 py-32">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">合作</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem title="资金捐赠" description="为推进开源项目、开源生态的繁荣发展，望更多科技企业加入，与其他捐赠人共同建设开源事业。" to="/cooperation/financial">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-1.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem title="项目捐赠" description="可获品牌提升、资源整合、法律支持等全方位助力，且能维持项目独立性和社区活力。" to="/cooperation/project">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-2.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem title="合作伙伴" description="了解我们有有哪些合作伙伴" to="/cooperation/partner">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-3.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
      </ul>
    </li>

    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">附加信息</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem title="捐赠流程" description="了解捐赠的具体流程" to="/cooperation">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-4.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem title="项目募集说明" description="了解项目募集流程及所需材料是什么" href="https://www.openeuler.openatom.cn/">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-5.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem title="联系我们" description="联系我们了解更多相关内容" href="#">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-6.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem title="常见问题" href="#">
            <template #icon>
              <img data-src="@/home/assets/header/cooperation-7.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
      </ul>
    </li>

    <ResourceTools />
  </ul>
</template>
